import { render, staticRenderFns } from "./DashboardKPI.vue?vue&type=template&id=3a392135&scoped=true&"
import script from "./DashboardKPI.vue?vue&type=script&lang=js&"
export * from "./DashboardKPI.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./DashboardKPI.vue?vue&type=style&index=0&id=3a392135&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3a392135",
  null
  ,true
)

export default component.exports